import React from 'react'

import { useSaveTemplate } from './_request/saveTemplate'
import { useTemplate } from './_load/TemplateLoader'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditTemplateForm = () => {
  const template = useTemplate()
  const [onSubmit, { loading, error }] = useSaveTemplate()

  const initialState = template ? template : { type: 'dynamic_pdf' }

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={initialState}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditTemplateForm
